import React, { useContext } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { PreferLocationContext } from '../../../../services/prefer-location/prefer-location.context';
export const TypeSelect = () => {
  const { type, setType } = useContext(PreferLocationContext);

  const handleChange = (event) => {
    setType(event.target.value);
  };

  return (
    <FormControl style={{ minWidth: 300 }}>
      <InputLabel id='select-plcae'>Please select place</InputLabel>
      <Select labelId='select-plcae' value={type} onChange={handleChange}>
        <MenuItem value={'cafe'}>Cafe</MenuItem>
        <MenuItem value={'restaurant'}>Restaurant</MenuItem>
        <MenuItem value={'fast_food'}>Fast food</MenuItem>
      </Select>
    </FormControl>
  );
};
